@use "../../styles/variables" as vars;

.group {
  display: grid;
  gap: 7px;
  padding: 0;
  border: 0;

  legend {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 3px;
    color: vars.$color-muted;
    font-family: vars.$font-medium;
    font-size: 15px;

    span {
      color: vars.$color-primary;
      font-size: 18px;
    }
  }
}

.plain {
  .options {
    gap: 6px 8px;
  }
}

.options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 8px;
  margin-top: 4px;

  label {
    display: flex;
    min-height: 36px;
    align-items: center;
    gap: 7px;
    padding: 3px 8px;
    border: 1px solid vars.$color-border;
    border-radius: vars.$radius-sm;
    background: vars.$color-surface;
    cursor: pointer;
    transition: border-color 0.3s ease, background-color 0.3s ease;

    span {
      font-size: 15px;
    }

    &:has(input:checked) {
      border-color: vars.$color-secondary;
      background: #fff8d7;
    }
  }

  input {
    width: 16px;
    height: 16px;
    margin: 0;
    appearance: none;
    border: 1px solid #8b8b8b;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;

    &:checked {
      border-color: vars.$color-success;
      background: vars.$color-success;
      box-shadow: inset 0 0 0 3px #fff;
    }

    &:focus-visible {
      outline: 2px solid vars.$color-secondary;
      outline-offset: 2px;
    }
  }
}

.error {
  color: vars.$color-error;
  font-size: 13px;
  font-weight: 700;
}

.hint {
  color: vars.$color-muted;
  font-size: 13px;
}

.group:disabled {
  .options label {
    border-color: vars.$color-border;
    background: #f2f1ef;
    cursor: not-allowed;
    opacity: 0.72;
  }

  .options input {
    cursor: not-allowed;
  }
}

.invalid {
  color: vars.$color-primary;
  animation: shake 0.3s ease-in-out;

  label {
    border-color: vars.$color-primary;
  }
}

.valid {
  color: vars.$color-success;

  label:has(input:checked) {
    border-color: vars.$color-secondary;
  }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
}

@media (min-width: 1081px) and (max-height: 1250px) {
  .group {
    gap: 4px;

    legend {
      margin-bottom: 1px;
    }
  }

  .options {
    margin-top: 1px;

    label {
      min-height: 32px;
      padding: 2px 7px;
    }
  }
}

@media (min-width: 1081px) {
  .group {
    legend {
      font-size: 13px;

      span {
        font-size: 14px;
      }
    }
  }

  .options {
    label {
      min-height: 32px;

      span {
        font-size: 13px;
      }
    }
  }

  .error {
    font-size: 11px;
  }

  .hint {
    font-size: 11px;
  }
}

@media (max-width: 600px) {
  .group {
    legend {
      font-size: 13px;

      span {
        font-size: 16px;
      }
    }
  }

  .options label {
    min-height: 32px;

    span {
      font-size: 13px;
    }
  }

  .error {
    font-size: 11px;
  }

  .hint {
    font-size: 11px;
  }
}
